import { render, staticRenderFns } from "./RegulationUpdateInfo.vue?vue&type=template&id=216bc667&scoped=true"
import script from "./RegulationUpdateInfo.vue?vue&type=script&lang=ts"
export * from "./RegulationUpdateInfo.vue?vue&type=script&lang=ts"
import style0 from "./RegulationUpdateInfo.vue?vue&type=style&index=0&id=216bc667&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216bc667",
  null
  
)

export default component.exports